import React from "react";
import {NavLink, Route, Switch, withRouter} from 'react-router-dom';
import {Col, Layout, Menu, Row} from "antd";
import {
    MenuFoldOutlined,
    MenuUnfoldOutlined,
    HomeOutlined,
    SettingOutlined,
    FileOutlined,
    AppstoreOutlined
} from "@ant-design/icons";

import './route.css'
import RouteList from "./componets/route/route-list";
import GrafanaFrame from "./componets/grafana-frame";
import KibanaFrame from "./componets/kibana-frame";
import SubMenu from "antd/es/menu/SubMenu";
import AuthGroupList from "./componets/auth/auth-group-list";
import ApiUserList from "./componets/auth/api-user-list";
import Login from "./componets/login";
import {Cookies, withCookies} from "react-cookie";
import {instanceOf} from 'prop-types';
import {request} from "./utils/utils";
import { config } from "./domains/config";

const {Header, Sider, Content} = Layout;

interface RouteStatus {
    selectMenuKeys: string[]
    collapsed: boolean,
    currentTab: string,
    theme: any,
    config?: config
}

export class MyRoute extends React.Component<any, RouteStatus> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };

    constructor(props: Readonly<any> | any) {
        super(props);

        let location = props.location
        let currentIndex = '1'
        if (location.pathname === '/web/')
            currentIndex = '1'
        else if (location.pathname === '/web/authgroup')
            currentIndex = '2'
        else if (location.pathname === '/web/apiuser')
            currentIndex = '3'
        else if (location.pathname === '/web/log')
            currentIndex = '4'
        else if (location.pathname === '/web/monitor')
            currentIndex = '5'

        this.state = {
            selectMenuKeys: [currentIndex],
            collapsed: false,
            currentTab: '1',
            theme: 'light'
        }

        request({url: "/web/config/site-config.json"}).then(res => {
            let data: config = res.date;
            debugger
            this.setState({config: data})
        })
    }

    componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<RouteStatus>, snapshot?: any) {
        const {cookies} = this.props;
        if (!cookies.get("token") && window.location.pathname !== '/web/login') {
            window.location.href = '/web/login'
        }
    }

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    themeToggle = (checked: boolean, event: Event) => {
        this.setState({theme: "dark"})
    }

    handleLoginSuccess = (token: String) => {
        const {cookies} = this.props;
        cookies.set("token", token, {path: "/"})
        window.location.href = '/web/'

    }

    render() {
        return (
            <Layout className='full-height' style={{display: "flex"}}>

                <Sider theme={this.state.theme} trigger={null} collapsible collapsed={this.state.collapsed}
                       className='sider'>
                    <div className="logo" style={{height: 50}}/>
                    <Menu theme={this.state.theme} mode="inline" defaultSelectedKeys={this.state.selectMenuKeys}>
                        <Menu.Item key="1" icon={<HomeOutlined/>}>
                            <NavLink to={'/web/'}>路由配置</NavLink>
                        </Menu.Item>
                        <SubMenu key="submenu" icon={<AppstoreOutlined/>} title={"认证配置"}>
                            <Menu.Item key="2" icon={<SettingOutlined/>}>
                                <NavLink to={'/web/authgroup'}>认证组配置</NavLink>
                            </Menu.Item>
                            <Menu.Item key="3" icon={<SettingOutlined/>}>
                                <NavLink to={'/web/apiuser'}>ApiUser配置</NavLink>
                            </Menu.Item>
                        </SubMenu>

                        <Menu.Item key="4" icon={<FileOutlined/>}>
                            <a href={this.state.config?.kibanaPath} target="_blank">日志监控</a>
                        </Menu.Item>
                        <Menu.Item key="5" icon={<FileOutlined/>}>
                            <a href={this.state.config?.grafanaPath} target="_blank">集群状态监控</a>
                        </Menu.Item>
                    </Menu>
                </Sider>
                <Layout className={"site-layout"}>
                    <Header
                        className={"site-layout-background site-layout-header-display " + this.state.theme + '-theme'}>
                        <Row align='middle'>
                            <Col span={1}>
                                {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                                    className: 'trigger',
                                    onClick: this.toggle,
                                })}
                            </Col>
                            <Col span={5}>
                                <label style={{fontSize: 20}}>鹏业微服务基础设施</label>
                            </Col>
                        </Row>
                    </Header>
                    <Content className={"site-content " + this.state.theme + '-theme'}>
                        <Switch>
                            <Route exact path={'/web/'}><RouteList/></Route>
                            <Route path={'/web/authgroup'}><AuthGroupList/> </Route>
                            <Route path={'/web/apiuser'}><ApiUserList/> </Route>
                            <Route path={'/web/log'}><KibanaFrame/></Route>
                            <Route path={'/web/monitor'}><GrafanaFrame/></Route>
                            <Route path={'/web/login'}><Login onLoginSuccess={this.handleLoginSuccess}/></Route>
                        </Switch>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const routeComponent = withRouter(props => <MyRoute {...props} />);
export default withCookies(routeComponent)
